import { render, staticRenderFns } from "./inputTabSimpan.vue?vue&type=template&id=6dede67c"
import script from "./inputTabSimpan.vue?vue&type=script&lang=js"
export * from "./inputTabSimpan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports